// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.title-container__syQsi {
  display: grid;
  grid-template-columns: 37% 13% 21% 20%;
  grid-template-rows: 32px;
  background-color: #6c7ae0;
  border-radius: 4px 4px 0 0;
  justify-items: start;
  padding: 7px 10px;
  gap: 15px;
  border: 1px solid #8f8f8f;
  border-bottom: none;
  box-sizing: border-box;
  justify-items: start;
}

.main-container__Y16Au {
  display: grid;
  grid-template-columns: 37% 13% 21% 20%;
  grid-template-rows: minmax(32px, auto);
  justify-items: start;
  align-items: center;
  padding: 4px 0 4px 10px;
  gap: 15px;
  box-sizing: border-box;
  border: 1px solid #8f8f8f;
  border-top: none;
}

.main-all-container__nZ5E1 {
  padding-top: 18px;
}

.quantity-row__Z1YKT,
.unit-price-per-week-row__mHw0i,
.total-price-per-week-row__C8Ovg {
  display: flex;
  justify-content: center;
}

.main-container__Y16Au:first-child {
  border: 1px solid #8f8f8f;
}

.main-container__Y16Au:last-of-type {
  border-top: none;
  border-radius: 0 0 6px 6px;
}

.total-weekly-price__FfMbx {
  display: flex;
  justify-content: space-between;
  padding: 30px 10px 10px;
}

@media print {
  body {
    background-color: white; /* Set the background color you want for printed pages */
  }
  .title-container__syQsi {
    border-bottom: 1px solid #8f8f8f;
    -webkit-print-color-adjust: exact !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/summary-weekly-hire-component/style.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sCAAsC;EACtC,wBAAwB;EACxB,yBAAyB;EACzB,0BAA0B;EAC1B,oBAAoB;EACpB,iBAAiB;EACjB,SAAS;EACT,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,sCAAsC;EACtC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;EAGE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE;IACE,uBAAuB,EAAE,wDAAwD;EACnF;EACA;IACE,gCAAgC;IAChC,4CAA4C;EAC9C;AACF","sourcesContent":[".title-container {\n  display: grid;\n  grid-template-columns: 37% 13% 21% 20%;\n  grid-template-rows: 32px;\n  background-color: #6c7ae0;\n  border-radius: 4px 4px 0 0;\n  justify-items: start;\n  padding: 7px 10px;\n  gap: 15px;\n  border: 1px solid #8f8f8f;\n  border-bottom: none;\n  box-sizing: border-box;\n  justify-items: start;\n}\n\n.main-container {\n  display: grid;\n  grid-template-columns: 37% 13% 21% 20%;\n  grid-template-rows: minmax(32px, auto);\n  justify-items: start;\n  align-items: center;\n  padding: 4px 0 4px 10px;\n  gap: 15px;\n  box-sizing: border-box;\n  border: 1px solid #8f8f8f;\n  border-top: none;\n}\n\n.main-all-container {\n  padding-top: 18px;\n}\n\n.quantity-row,\n.unit-price-per-week-row,\n.total-price-per-week-row {\n  display: flex;\n  justify-content: center;\n}\n\n.main-container:first-child {\n  border: 1px solid #8f8f8f;\n}\n\n.main-container:last-of-type {\n  border-top: none;\n  border-radius: 0 0 6px 6px;\n}\n\n.total-weekly-price {\n  display: flex;\n  justify-content: space-between;\n  padding: 30px 10px 10px;\n}\n\n@media print {\n  body {\n    background-color: white; /* Set the background color you want for printed pages */\n  }\n  .title-container {\n    border-bottom: 1px solid #8f8f8f;\n    -webkit-print-color-adjust: exact !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title-container": `title-container__syQsi`,
	"main-container": `main-container__Y16Au`,
	"main-all-container": `main-all-container__nZ5E1`,
	"quantity-row": `quantity-row__Z1YKT`,
	"unit-price-per-week-row": `unit-price-per-week-row__mHw0i`,
	"total-price-per-week-row": `total-price-per-week-row__C8Ovg`,
	"total-weekly-price": `total-weekly-price__FfMbx`
};
export default ___CSS_LOADER_EXPORT___;
